module.exports = __webpack_public_path__ + "img/theme2.83d18bb3.png";